import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c52ed02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "phone-submit" }

import { onMounted, reactive, ref } from 'vue'
import { bindMobile, sendPhoneVerifyCode } from '@/api/user'
import { ERR_SUCCESS } from '@/api/config'
import { ElMessage } from 'element-plus/lib'
import Schema from 'async-validator'
import store from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'mobile',
  props: ['hideDialog', 'mobile'],
  setup(__props) {

const formRef = ref(null)

const disabled = ref(false)
const loading = ref(false)
const btnContent = ref('获取验证码')
let timer: NodeJS.Timeout | null = null
let isTimerRunning = false

const form = reactive({
  phoneNum: '',
  verifyNum: ''
})

// eslint-disable-next-line no-undef
const props = __props
onMounted(() => { form.phoneNum = props.mobile })

const rules = reactive({
  phoneNum: [
    { required: true, message: '请输入手机号码', trigger: 'blur' },
    { pattern: /^1[358]\d{9}$/, message: '本站仅支持13/15/18开头的手机号码', trigger: 'blur' }
  ],
  verifyNum: [
    { required: true, message: '请输入验证码', trigger: 'blur' },
    { pattern: /^\d{4}$/, message: '请输入4位数字的验证码', trigger: 'blur' }
  ]
})

function startTimer () {
  let count = 10
  isTimerRunning = true // Set the flag to indicate that the timer is running
  timer = setInterval(() => {
    if (count <= 0) {
      clearInterval(timer!)
      timer = null
      btnContent.value = '获取验证码'
      isTimerRunning = false // Reset the flag when the timer is stopped
      return
    }
    btnContent.value = `${count} 秒后重新获取`
    count--
  }, 1000)
}

async function sendSmsCode () {
  const validator = new Schema({
    phoneNum: rules.phoneNum
  })

  try {
    await validator.validate({ phoneNum: form.phoneNum })
    const response = await sendPhoneVerifyCode({ mobile: form.phoneNum })
    if (response.code === 506) {
      ElMessage.error('手机号码已经被绑定，请更换其他手机号码。')
      // ElMessage.error(response.message)
      return
    }

    if (isTimerRunning) {
      return
    }
    loading.value = true
    disabled.value = true
    setTimeout(() => {
      loading.value = false
      btnContent.value = '180 秒重新获取'
      disabled.value = false
      startTimer()
    }, 1000)
  } catch (error) {
    ElMessage.error('请正确填写手机号码！')
  }
}

async function validateAndSubmit () {
  const validator = new Schema(rules)

  try {
    await validator.validate(form)
    // Proceed with form submission logic...
    const { code, message } = await bindMobile({
      mobile: form.phoneNum,
      // eslint-disable-next-line @typescript-eslint/camelcase
      mobile_verify_code: form.verifyNum
    })
    if (code === ERR_SUCCESS) {
      await store.dispatch('user/getInfo')
      ElMessage.success(message)
      props.hideDialog()
    } else {
      ElMessage.error(message)
    }
  } catch (error) {
    ElMessage.error('请正确填写相关字段信息!')
  }
}

function cancel () {
  if (timer) {
    clearInterval(timer)
    isTimerRunning = false
  }
  props.hideDialog()
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    model: form,
    rules: rules,
    ref_key: "formRef",
    ref: formRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "手机号",
        prop: "phoneNum"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            class: "phoneNum",
            modelValue: form.phoneNum,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.phoneNum) = $event)),
            placeholder: "请输入手机号码",
            clearable: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "验证码",
        prop: "verifyNum"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            class: "verifyNum",
            modelValue: form.verifyNum,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.verifyNum) = $event)),
            placeholder: "请输入验证码",
            clearable: ""
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            disabled: disabled.value || loading.value,
            loading: loading.value,
            onClick: sendSmsCode
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(btnContent.value), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _withModifiers(validateAndSubmit, ["stop"])
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}
}

})